module.exports = __webpack_public_path__ + "img/location.d3f5678e.svg";